export function currentTime(){
  return moment().format('hh:mm:ss A');
}

// localstorage message status
export const localStorageMessageStatus = {

  setStorage: function(key, value){
    localStorage.setItem(key, value);
  },

  getStorage: function(key, title, text, specialKey = ""){
    
    let item = localStorage.getItem(key);
    if (item){
      Packs.application.largeNotification("success", I18n.t(title), I18n.t(text, { [specialKey]: item }), currentTime());
      localStorage.removeItem(key); 
    }
  }
}

export const printCardSettings = (w, h, url, windowName) => {
  let iframe = document.getElementById('print-iframe');
  if (iframe) { iframe.remove(); }

  iframe = document.createElement('iframe');
  iframe.id = 'print-iframe';
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  iframe.src = url;
  document.body.appendChild(iframe);

  iframe.onload = function() {
    var originalTitle = document.title;
    if (windowName) document.title = windowName;
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = function() {
      document.title = originalTitle;
      iframe.remove();
    };
  };

  return false;
}